<app-title-bar rootBreadCrumbs="['i18n.core.navigation.export-configuration']" titleText="i18n.core.navigation.configurationTemplates"></app-title-bar>
<div>
  <div class="row grow w-100">
    <div class="col-4 d-flex justify-content-between">
      <span>
        {{'i18n.domain.export-configuration.templates.header' | translate }}
      </span>
      <span class="e-icons icon-add e-icon-big"
            title="{{ 'i18n.domain.export-configuration.templates.add-button-tooltip' | translate }}"
            (click)="addConfigurationTemplate()">
      </span>
    </div>
  </div>
  <div class="row grow w-100">
    <div class="col-4">
      <app-configuration-templates-overview [isStandalone]="true" (rowSelected)="exportInterfaceConfigurationSelected($event)" [selectedTemplateId]="selectedTemplateId" [mode]="null">
      </app-configuration-templates-overview>
    </div>
    @if (configuration$ | async; as config) {
      <div class="col-8 h-100 right">
        <div class="e-card">
          <div class="e-card-content h-100">
            <app-configuration-forms-overview></app-configuration-forms-overview>
          </div>
          <div class="e-card-actions">
            <div class="d-flex">
              <div class="btn-group me-auto">
                  <button type="button"
                          (click)="deleteConfigurationTemplate()"
                          class="btn btn-outline-danger me-2 btn-fixedw rounded">
                    <span class="e-icons ibm-erase"></span>
                    <span class="e-icons icon-erase danger me-2"></span>
                    {{ 'i18n.domain.export-configuration.shared.buttons.delete' | translate }}
                  </button>
              </div>
              <div class="btn-group ms-auto">
                <button type="reset"
                        (click)="closeForm()"
                        class="btn btn-outline-secondary me-2 btn-fixedw rounded">
                  {{ 'i18n.domain.export-configuration.shared.buttons.discard' | translate }}
                </button>
                <button type="submit"
                        (click)="saveConfigurationTemplate()"
                        class="btn btn-outline-primary btn-fixedw rounded">
                  {{ 'i18n.domain.export-configuration.shared.buttons.save' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
